// extracted by mini-css-extract-plugin
module.exports = {"section":"PreviewBanner_section__cXva4"};